import { useGetMySummary } from "@/api/user/useGetMySummary";
import { useAuth } from "@/auth/AuthContext";
import React from "react";
import { Navigate } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

// only displays route if user has not completed the onboarding process
export const HasNotOnboardedRoute: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();
  const { data: userSummary } = useGetMySummary();

  const hasOnboarded =
    userSummary?.hasCompletedPersonalityTest && userSummary?.hasCompletedSignupFlow;

  return hasOnboarded ? <Navigate to="/home" /> : <>{children}</>;
};
